import { Component, Input, OnInit } from '@angular/core';
import { JournalPost } from '../../interfaces/journal-post';

@Component({
  selector: 'app-journal-post-preview',
  templateUrl: './journal-post-preview.component.html',
  styleUrls: ['./journal-post-preview.component.scss']
})
export class JournalPostPreviewComponent implements OnInit {
  @Input() post: JournalPost;
  @Input() index: number;

  constructor() { }

  ngOnInit() {
  }

}
